import React, { useRef } from "react";
import { Container, List, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com6 = () => {
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  useScrollFadeIn(ref1, ref2, ref3, ref4);
  const { t } = useTranslation("whatIsSketch");
  const language = useSelector(selectLanguage);
  return (
    <Wrapper>
      <span>{t("6-1")}</span>
      <Container language={language}>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/8f788a37WhatIsSketch_24.svg"
          alt=""
        />
        <TextBox ref={ref1} className="fade-in">
          <span>{t("6-2")}</span>
          <span>{t("6-3")}</span>
          <List>
            <span></span>
            <span>{t("6-4")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-5")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-6")}</span>
          </List>
        </TextBox>
        <TextBox ref={ref2} className="fade-in">
          <span>{t("6-7")}</span>
          <span>{t("6-8")}</span>
          <List>
            <span></span>
            <span>{t("6-9")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-10")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-11")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-12")}</span>
          </List>
        </TextBox>
        <TextBox ref={ref3} className="fade-in">
          <span>{t("6-13")}</span>
          <span>{t("6-14")}</span>
          <List>
            <span></span>
            <span>{t("6-15")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-16")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-17")}</span>
          </List>
        </TextBox>
        <TextBox ref={ref4} className="fade-in">
          <span>{t("6-18")}</span>

          <List>
            <span></span>
            <span>{t("6-19")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-20")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-21")}</span>
          </List>
          <List>
            <span></span>
            <span>{t("6-22")}</span>
          </List>
        </TextBox>
      </Container>
    </Wrapper>
  );
};

export default Com6;
